import { useMemo } from "react";

import useSupportedChains, { type SupDicChainData } from "@/hooks/api/useSupportedChains";

export function useChainMap() {
  const { data, isLoading } = useSupportedChains();
  const chainMap = useMemo(() => data?.reduce<Record<number, SupDicChainData>>((acc, chain) => ({ ...acc, [chain.chain_id]: chain }), {}) ?? {}, [data]);

  return {
    chainMap,
    isLoading,
  };
}
